<template>
  <v-btn
    @click.native="$emit('exportExcel')"
    :class="classes"
    :loading="loading"
    :disabled="loading"
  >
    {{ name }}
  </v-btn>
</template>

<script>
import { watch } from "@vue/composition-api";

import useProxy from "@/hooks/useProxy";

import { saveRmraCustomEvent } from "@/utils/rmr-analytics";

export default {
  name: "ExportExcelVSButton",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    excelData: {
      type: Blob,
      default: () => new Blob([""], { type: "text/plain" }),
    },
    filename: {
      type: String,
      default: "export.xlsx",
    },
    name: {
      type: String,
      default: "Export Excel",
    },
    classes: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const { route } = useProxy();

    // =>  METHODS
    const exportExcel = () => {
      if (props.disabled || props.excelData.length === 0) {
        return;
      }

      const downloadLink = document.createElement("a");
      const blob = new Blob([props.excelData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = props.filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };

    // =>  COMPUTED

    // =>  WATCH
    watch(
      () => props.excelData,
      () => {
        exportExcel();
        saveRmraCustomEvent(route, "export");
      }
    );

    // =>  HOOKS

    // =>  DATA
    return {};
  },
};
</script>
